import { RawComment, RawReaction } from '../interfaces/comment';
import { makeAutoObservable } from 'mobx';
import { rootStore } from '../rootStore';

export class CommentModel {
  // Common
  id: string;
  type: number;
  assigneeId?: string | null;
  comment?: string | null;

  // Dates
  createdOn: Date;
  updatedTime: Date;
  dueDate?: Date | null;
  previousDueDate?: Date | null;

  // Relational
  createdById: string;
  updatedById: string;

  // Others
  priority?: number | null;
  previousPriority?: number | null;
  group?: string | null;
  previousGroup?: string | null;
  status?: boolean | null;
  estimateTime?: number | null;
  isArchived?: boolean | null;
  reactions: RawReaction[];
  Files: any[];
  replyId?: string | null;
  isGithub: boolean;

  constructor(rawComment: RawComment) {
    makeAutoObservable(this);

    // Common
    this.id = rawComment.id;
    this.type = rawComment.type;
    this.assigneeId = rawComment.assigneeId;
    this.comment = rawComment.comment;

    // Dates
    this.createdOn = new Date(rawComment.createdOn);
    this.updatedTime = new Date(rawComment.updatedTime);
    this.dueDate = rawComment.dueDate ? new Date(rawComment.dueDate) : null;
    this.previousDueDate = rawComment.previousDueDate ? new Date(rawComment.previousDueDate) : null;

    // Relational
    this.createdById = rawComment.createdBy;
    this.updatedById = rawComment.updatedBy;

    // Others
    this.priority = rawComment.priority;
    this.previousPriority = rawComment.previousPriority;
    this.group = rawComment.group;
    this.previousGroup = rawComment.previousGroup;
    this.status = rawComment.status;
    this.estimateTime = rawComment.estimateTime;
    this.isArchived = rawComment.isArchived;
    this.reactions = rawComment.reactions ?? [];
    this.Files = rawComment.Files ?? [];
    this.replyId = rawComment.reply;
    this.isGithub = rawComment.isGithub ?? false;
  }

  get createdBy() {
    return rootStore.workspaceStore.currentWorkspace?.users.find((user) => user.id === this.createdById);
  }

  get updatedBy() {
    return rootStore.workspaceStore.currentWorkspace?.users.find((user) => user.id === this.updatedById);
  }

  addReaction(rawReaction: RawReaction) {
    const existingReactionIndex = this.reactions.findIndex(
      (reaction) => reaction.ReactionType === rawReaction.ReactionType && reaction.UserId === rawReaction.UserId
    );

    if (existingReactionIndex >= 0) {
      this.reactions.splice(existingReactionIndex, 1);
    } else {
      this.reactions.push(rawReaction);
    }
  }

  get reply() {
    return rootStore.taskStore.currentTask?.comments.find((comment) => comment.id === this.replyId);
  }
}

export const createObservableComment = (rawComment: RawComment) => {
  return new CommentModel(rawComment);
};
